import {  PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { UnidadeComPessoaResponse, FiltroUnidadeComPessoas } from "./typings/unidade";

function useUnidadeComPessoas(
  query: FiltroUnidadeComPessoas,
  enabled = true,
) {
  return useQuery(
    [`/v1/unidades/com-pessoas`, query],
    async () => {
      const res = await axios.get<
        PaginateResult<UnidadeComPessoaResponse>
      >(`/v1/unidades/com-pessoas`, {
        params: { ...query },
      });

      return res.data;
    },
    {
      enabled,
    }
  );
}

export default useUnidadeComPessoas;
